angular.module('unergie.main')
.directive('birthdate', () =>
    ({
        require: 'ngModel',
        link(scope, elm, attr, ctrl) {
            ctrl.$validators.isBirthdate = (value) => moment(value, 'DDMMYYYY').isValid()
        },
    }),
)
